import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { get_committee_members_data, show_committee_names } from "../../api/User";
import "../Admin/table.css"
import { toast } from "react-toastify";
import "../Admin/table.css";
import TablePagination from '@mui/material/TablePagination';
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

const CommitteeMembersDetailsAdmin = ({ designation }) => {
  const [selectedDistrictCode, setSelectedDistrictCode] = useState('');
  const [selectedDistrictName, setSelectedDistrictName] = useState('');
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const gpID = (sessionStorage.getItem("gp_data") == 1 ? "all" : sessionStorage.getItem("gp_data")) || "";
  const [filteredData, setFilteredData] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [committeeNames, setcommitteeNames] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const fetchData = async () => {
    const data = {
      id: userId,
      role_id: role_id,
      gp_data_id: gpID,
    };
    try {
      const res = await get_committee_members_data(token, data);
      console.log(res.data);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const fetchCommitteeNames = async () => {
      try {
        const res = await show_committee_names(token);
        if (res.status === "success") {
          setcommitteeNames(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching committee names:", error);
        toast.error("An error occurred while fetching committee names.", { autoClose: 1000 });
      }
    };
    fetchCommitteeNames();
  }, [token]);
  useEffect(() => {
    fetchData();
  }, []);
  const handleDistrictChange = (event) => {
    const selectedCode = event.target.value;
    const selectedDistrict = committeeNames.filter((item) => item.committee_id == selectedCode);
    if (selectedDistrict) {
      setSelectedDistrictName(selectedDistrict[0].committee_name);
      setSelectedDistrictCode(selectedCode)
    }
  };
  const filteredRecords = filteredData
    .filter((row) => {
      const districtMatch = !selectedDistrictCode || row.committee_name === selectedDistrictName;
      return districtMatch;
    });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginatedData = filteredRecords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
        `}
      </style>

      <div className="container-fluid" style={{ height: "91vh" }}>
        {/* <h2
          className="pt-10"
          style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}
        >
          Committee Members Details
        </h2> */}
        <div style={{padding: '16px', marginTop: "-17px", }}>
          <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>
            Committee Members Details
          </h2>
        </div>

        <div >
          <div className="container-fluid mt-3 p-0">
            <div className="sticky-top bg-white py-2">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0"></h4>
                <div className="d-flex">
                  <div className="me-3">
                    <select
                      className="form-select dropdown-custom"
                      value={selectedDistrictCode}
                      onChange={handleDistrictChange}
                    >
                      <option value="" disabled>
                        Select Committee Name
                      </option>
                      {committeeNames.map((item) => (
                        <option
                          key={item.committee_id}
                          value={item.committee_id}
                        >
                          {item.committee_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="table-responsive " style={{ overflowX: "auto", maxHeight: "70vh", marginTop: "20px" }}>
                <Table aria-label="simple table">
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "rgb(232 233 246)",
                    }}
                  >
                    <TableRow>
                      <TableCell
                        style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                        align="center"
                      >
                        SR NO.
                      </TableCell>
                      <TableCell
                        style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                        align="center"
                      >
                        COMMITTEES NAME
                      </TableCell>
                      <TableCell
                        style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                        align="center"
                      >
                        SUSTAINABLE GOAL
                      </TableCell>
                      <TableCell
                        style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                        align="center"
                      >
                        MEMBER NAME
                      </TableCell>
                      <TableCell
                        style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                        align="center"
                      >
                        MOBILE NUMBER
                      </TableCell>
                      <TableCell
                        style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                        align="center"
                      >
                        ACTIVE STATUS
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((row, index) => (
                        <TableRow
                          key={row.id + (page * rowsPerPage)}
                        >
                          <TableCell
                            style={{ whiteSpace: "nowrap" }}
                            align="center"
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap" }}
                            align="center"
                          >
                            {row.committee_name}
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap" }}
                            align="center"
                          >
                            {row.sub_committee_names}
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap" }}
                            align="center"
                          >
                            {row.member_name}
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap" }}
                            align="center"
                            className="custom-class"
                          >
                            {row.mobile_no}
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap" }}
                            align="center"
                            className="custom-class"
                          >
                            {row.is_active === 1 ? "Active" : "Inactive"}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No data found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
            </div>
            <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} showFirstButton showLastButton components={{ FirstPageIcon: FirstPage, LastPageIcon: LastPage, NextPageIcon: KeyboardArrowRight, BackPageIcon: KeyboardArrowLeft, }} />
          </div>
        </div>
      </div>
    </>
  );
};
export default CommitteeMembersDetailsAdmin;
